import React from "react";
import { Button, Card, Typography } from "antd";
import accessDeniedImg from "../../assets/imgs/403.png";
import "./access-denied.scss";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const { Title, Text } = Typography;

const AccessDenied: React.FC = () => {
  return (
    <div className="access-denied-container">
      <Card className="access-denied-card">
        <Title level={4} className="access-denied-title">
          Access Denied
        </Title>
        <Text type="secondary">You do not have access to this page.</Text>
        <div className="access-denied-image-wrapper">
          <img
            src={accessDeniedImg}
            alt="Access Denied"
            className="access-denied-image"
          />
        </div>
        <Button type="primary" onClick={() => (window.location.href = "/")}>
          Back to Dashboard{" "}
          <FontAwesomeIcon icon={faArrowRight} style={{ marginLeft: 8 }} />
        </Button>
      </Card>
    </div>
  );
};

export default AccessDenied;
